import { Container } from 'react-bootstrap';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import useFirebaseAuthMonitor from './hooks/useFirebaseAuthMonitor';
import 'react-toastify/dist/ReactToastify.css';
import DeliveryPartnerHeader from './components/DeliveryPartnerHeader';
import DeliveryPartnerFooter from './components/DeliveryPartnerFooter';

const DeliveryPartnerApp = () => {
  useFirebaseAuthMonitor();
  return (
    <>
      <DeliveryPartnerHeader />
      <main className="py-3">
        <Container>
          <Outlet />
          <ScrollRestoration />
        </Container>
      </main>
      <DeliveryPartnerFooter />
      <ToastContainer />
    </>
  );
};

export default DeliveryPartnerApp;